<template>
    <div class="container-fluid">
        <!-- breadbrumb -->
        <app-breadcrumb pageTitle="Items"></app-breadcrumb>
        
        <!-- search & filters -->
        <div class="row mb-3">
            <div class="col-12">
                <form>
                    <div class="input-group">
                        <input v-model="searchBox" @keyup="performSearch" type="text" class="form-control no-lines bg-white" placeholder="find items by title or description">
                        <div class="input-group-prepend">
                            <button @click.prevent="performSearch" class="input-group-text bg-dark-green text-light"><i class="fas fa-search"></i></button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <!-- my items -->
        <div v-if="mySellings" class="row">
            <app-user-item v-for="(item, i) in itemsArr" :key="i" :item="item" :sn="i+1" :portal="true"></app-user-item>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { fuzzySearch } from '@/store/dry'

import Fuse from 'fuse.js'
import UserItem from '@/components/user/shared/UserItem.vue'
import Breadcrumb from '../shared/Breadcrumb.vue'
import LayoutShop from '@/layouts/Shop.vue'

export default {
    name: "Items",
    data() {
        return {
            searchBox: '',
            itemsArr: [],
        }
    },
    methods: {
        ...mapActions(['itemsIamSelling']),
        performSearch() {
            if(!this.mySellings.length) { return }
            if(!this.searchBox.length){
                return this.itemsArr = this.mySellings
            } 
            else {
                // use fuzzySearch to perform search
                const searchOptions = {
                    keys: [
                        "title",
                        "description"
                    ]
                };
                this.itemsArr = fuzzySearch(Fuse, this.mySellings, searchOptions, this.searchBox)
            }
        }
    },
    computed: {
        ...mapGetters(['sellings']),
        mySellings() {
            if(this.sellings && this.sellings !== null){
                this.itemsArr = this.sellings
                return this.sellings
            }
            return false
        },
    },
    components: {
        appUserItem: UserItem,
        appBreadcrumb: Breadcrumb
    },
    created() {
        this.itemsIamSelling().then(() => {}).catch((e) => {})
        this.$emit('update:layout', LayoutShop);
    }
}
</script>